import ProductCard from "./ProductCard";
import type { Product } from "@/types/database";

interface ProductGridProps {
  products: Product[];
}

const ProductGrid = ({ products }: ProductGridProps) => {
  if (products.length === 0) {
    return (
      <div className="text-center py-12">
        <p className="text-muted-foreground text-lg">No se encontraron productos</p>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
      {products.map((product) => (
        <ProductCard
          key={product.id}
          id={product.id}
          name={product.name}
          slug={product.slug}
          price={product.base_price}
          image={product.image_url || ''}
          category={product.category?.slug || ''}
          brand={product.brand?.name}
          variations={product.variations}
        />
      ))}
    </div>
  );
};

export default ProductGrid;
